import { Badge } from '@chakra-ui/react';

type StatusBadgeProps = {
	activeText:   string
	inactiveText: string
	isActive:     boolean
};

export const StatusBadge = ({ activeText, inactiveText, isActive }: StatusBadgeProps) => {
	return (
		<Badge colorScheme={isActive ? 'green' : 'red'}>
			{isActive ? activeText : inactiveText}
		</Badge>
	);
};
